import { IBooking } from '../../models/IBooking';
import { INewBooking } from '../../models/INewBooking';
import { fromLocalDateTime } from '../../../../../shared/i18n/date-time/LocalDateTime';
import { timeZone } from '../../../../../../config/common';
import { parseTime } from '../utils/parseTime';

export function adaptOriginalBookingToInitialNewBooking(
	originalBooking: IBooking,
	/**
	 * A Booking can't be mapped to a New Booking. At least not with the purpose of showing it in the Booking summary.
	 * The problem is that Aeroparker API doesn't allow us to retrieve the Ancillaries for an existing booking.
	 * This means that if we would show this data in the Partial Amend flow using an empty array for ancillaries,
	 * that any Booking that actually was made WITH ancillaries, will be shown WITHOUT and therefor show incorrect data including an incorrect total price.
	 */
): Partial<INewBooking> {
	const {
		parkingProductsQuote,
		personalDetails,
		vehicleDetails,
		travelDetails,
		daysInTotal,
	} = originalBooking;
	const entryDate = fromLocalDateTime({
		date: parkingProductsQuote.startDate,
		time: parseTime(parkingProductsQuote.startTime),
		zone: timeZone,
	});
	const exitDate = fromLocalDateTime({
		date: parkingProductsQuote.endDate,
		time: parseTime(parkingProductsQuote.endTime),
		zone: timeZone,
	});

	return {
		entryDate,
		entryTime: parkingProductsQuote.startTime,
		exitDate,
		exitTime: parkingProductsQuote.endTime,
		promoCode: parkingProductsQuote.promoCode,
		personalDetails,
		vehicleDetails,
		travelDetails,
		daysInTotal,
	};
}
